module.exports = __webpack_public_path__ + "img/image-1@2x.bc782cdb.png";